// src/components/Inspiration.jsx
export default function Inspiration() {
  return (
    <section id="inspiration" className="bg-white">
      <div className="mx-auto max-w-6xl px-6 py-10">
        <h2 className="text-center text-2xl md:text-3xl font-bold text-gray-900">
          Inspiration Collection
        </h2>
        <p className="text-center text-gray-500 mt-2">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </p>

        <div className="mt-8">
          <img
            src="/images/Group 113.png"  // ← tu imagen ya compuesta
            alt="Inspiration collection"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
}
